// ProductosXL utils - Sprint 44 Fase 3 Vista 3.
// Helpers compartidos: mediaUrl (resuelve /media/... contra el backend),
// asString (coerce para inputs controlados), blankForm (estado vacio del form)
// y TABS (estructura de tabs del form).
import { API_BASE } from '../../api/apiClient';

export function mediaUrl(rel) {
  if (!rel) return null;
  if (/^https?:\/\//.test(rel)) return rel;
  const base = API_BASE.replace(/\/api\/?$/, '');
  return base + rel;
}

export function asString(v) {
  return v === null || v === undefined ? '' : String(v);
}

export const blankForm = {
  codigo: '',
  nombre: '',
  descripcion: '',
  categoria: '',
  unidad_medida: 'UND',
  peso_kg: '',
  volumen_m3: '',
  marca: '',
  sku: '',
  precio_venta: '',
  costo_ultimo: '',
  costo_real: '',
  costo_promedio: '',
  estado: 'activo',
  is_active: true,
  imagen_url: null,
  imagen_thumbnail_url: null,
  stock: null,
  created_at: null,
  updated_at: null,
};

export const TABS = [
  { id: 'basicos',  label: 'Datos basicos' },
  { id: 'tecnica',  label: 'Informacion tecnica' },
  { id: 'precios',  label: 'Precios y costos' },
  { id: 'auditoria', label: 'Auditoria' },
];

export const TAB_BY_FIELD = {
  codigo: 'basicos', nombre: 'basicos', descripcion: 'basicos',
  categoria: 'basicos', unidad_medida: 'basicos', estado: 'basicos',
  marca: 'tecnica', sku: 'tecnica', peso_kg: 'tecnica', volumen_m3: 'tecnica',
  precio_venta: 'precios', costo_ultimo: 'precios',
};
